/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col, Checkbox, Radio, Form } from 'antd';
import { ASelect } from 'components/Antd/index';
import classes from './SelectJobType.module.scss';

const Group = styled(Row)`
  align-items: flex-end;
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-select-selection-item {
    font-size: 12px;
  }
`;

/**
 * SelectJobType
 * Should wrapped with Controlled Item
 * ex : <Form.Item>
 *  <SelectJobType></SelectJobType>
 * </Form.Item>
 * @param {*} param0
 * @returns
 */
const SelectJobType = ({ options, name, subSelectName, value: selectedOption, disabled, onJobTypeChange, isEdit }) => {
  const selectedValue = !!selectedOption ? typeof selectedOption === 'string' ? selectedOption : selectedOption.value : '';
  const SubOptions = React.useMemo(() => {
    if (!selectedOption) return [];
    const selected = options.find((option) => option.value === selectedValue);

    return selected ? selected.subSelectProps.options : [];
  }, [selectedOption]);

  const SubSelectDecorator = React.useMemo(() => {
    if (!selectedOption) return null;
    const selected = options.find((option) => option.value === selectedValue);
    if (!selected) return null;
    switch (selected.subSelectProps.type) {
      case 'checkbox':
        return Checkbox.Group;
      case 'radio':
        return Radio.Group;
      default:
        return ASelect;
    }
  }, [selectedOption]);

  return (
    <Group gutter={16} className={classes.wrapper}>
      <Col span={12}>
        <Form.Item name={name}>
          <ASelect
            value={selectedOption}
            options={options.map((option) => {
              return { value: option.value, label: option.label };
            })}
            onChange={val => {
              if (onJobTypeChange) onJobTypeChange(val);
            }}
            disabled={isEdit}
          />
        </Form.Item>
      </Col>
      {SubSelectDecorator ? (
        <Col>
          <Form.Item name={subSelectName}>
            <SubSelectDecorator
              options={SubOptions.map((option) => {
                return { value: option.value, label: option.label };
              })}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      ) : null}
    </Group>
  );
};

SelectJobType.displayName = 'SelectJobType';

SelectJobType.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  subSelectName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      subSelectProps: PropTypes.shape({
        type: PropTypes.oneOfType(['default', 'radio', 'checkbox']),
        options: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
          })
        ).isRequired,
      }) ,
    }).isRequired
  ).isRequired,
};

SelectJobType.defaultProps = {
  value: null,
  name: null,
  subSelectName: null,
};
export default SelectJobType;
